module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_28.11a62d33.png";